export const PublicSettings = {
  MAPSKEY: 'UI-SERVERLESS.PUBLIC.MAPSKEY',
  ACCOUNTMOBILE: 'UI-SERVERLESS.PUBLIC.ACCOUNTMOBILE',
  BASEURL: 'UI-SERVERLESS.PUBLIC.BASEURL',
  WEBSITE: 'UI-SERVERLESS.PUBLIC.WEBSITE',
  CURRENCY: 'UI-SERVERLESS.PUBLIC.CURRENCY',
  ORDERLINEPREFIX: 'UI-SERVERLESS.PUBLIC.ORDERLINEPREFIX',
  ORDERPROCESS: {
    USEFULLADDRESSINSHOPSEARCH: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.USEFULLADDRESSINSHOPSEARCH',
    PAYMENTSENABLED: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.PAYMENTSENABLED',
    BASKETPAYMENTS: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.BASKETPAYMENTS',
    DISCOUNTSENABLED: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.DISCOUNTSENABLED',
    SENTRYFEEDBACKENABLED: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.SENTRYFEEDBACKENABLED',
    SENDERTYPEENABLED: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.SENDERTYPEENABLED',
    SIGNINDISABLED: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.SIGNINDISABLED',
    LABELRETRYCOUNT: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.LABELRETRYCOUNT',
    LABELRETRYTIMEOUT: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.LABELRETRYTIMEOUT',
    SHOWAUTOPREPAYTOPUP: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.SHOWAUTOPREPAYTOPUP'
  },
  QUOTES: {
    ESTIMATEDDELIVERYOPTIONSENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.ESTIMATEDDELIVERYOPTIONSENABLED',
    RATINGENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.RATINGENABLED',
    LABELOPTIONSENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.LABELOPTIONSENABLED',
    SERVICEOPTIONSENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.SERVICEOPTIONSENABLED',
    SORTENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.SORTENABLED',
    CTAPROMOTESDDP: 'UI-SERVERLESS.PUBLIC.QUOTES.CTAPROMOTESDDP',
    SAMEDAYENABLED: 'UI-SERVERLESS.PUBLIC.QUOTES.SAMEDAYENABLED'
  },
  LINKS: {
    MY_ORDERS: 'UI-SERVERLESS.PUBLIC.LINKS.MYORDERS',
    ADD_PREPAY: 'UI-SERVERLESS.PUBLIC.LINKS.ADDPREPAY',
    SAVED_ADDRESSES: 'UI-SERVERLESS.PUBLIC.LINKS.SAVEDADDRESSES',
    PROHIB_ITEMS: 'UI-SERVERLESS.PUBLIC.LINKS.PROHIBITED.ITEMS'
  }
};
